module.exports = __webpack_public_path__ + "static/media/azubu-e3-preview.a664583e.mp4";